import styled from 'styled-components';
import { Tab } from '@material-ui/core';

export const StyledProviderTab = styled(Tab)`
    ${({ theme, $active }) => `
        background-color: ${$active ? theme.palette.common.primaryBlue : 'transparent'};
        border-radius: 24px;
        border-bottom: none;
        font-weight: ${$active ? '600' : '400'};
        font-size: 24px;
        line-height: 32px;
        color: ${$active ? theme.palette.common.white : theme.palette.common.gray2};
        text-transform: none;
        max-width: none;
        padding: 6px 25px;
    `}
`;

export const StyledPatientDetailTab = styled(Tab)`
    ${({ theme, $active }) => `
    font-family: Prompt !important;
    font-weight: 400 !important;
    text-transform: none;
    font-size: 16px;
    color: ${$active ? theme.palette.common.black : theme.palette.common.gray2};
    padding-left: 5px;
    padding-right: 5px;
    min-width: 0;
    `}
`;
